if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() { 
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }
 
    async onSubmitHandler(evt) {
      evt.preventDefault();// prevent the form from submitting by default
      this.submitButton.disabled = true;
      var obj = {}
      var keys_to_check = ["birth-name-input", "birth-date-day", "birth-date-month", "birth-date-year"]
      var keys_to_check_required = ["birth-weight-pounds-input", "birth-weight-input"]
      var keys_to_check_min = ["birth-weight-input"]

      var names = [];
      var lengths = []
      var weights = [];
      var dates = []
      var times = []
      var places = []
      for (var i = 1; i <= no_of_babies; i++) {
        for(var j in keys_to_check){
          var value = document.querySelector(`#${keys_to_check[j]}-${i}`).value;
          if(!value){
            document.querySelector(`button[data-actab-id="${i}"]`).click();
            document.querySelector(`#${keys_to_check[j]}-${i}`).style.border = ' 1px solid red';
            this.submitButton.disabled = false;
            return
          }
        }
        for(var l in keys_to_check_required){
          var value = document.querySelector(`#${keys_to_check_required[l]}-${i}`).value;
          var req = document.querySelector(`#${keys_to_check_required[l]}-${i}`).hasAttribute("required");
          if(!value && req){
            document.querySelector(`button[data-actab-id="${i}"]`).click();
            document.querySelector(`#${keys_to_check_required[l]}-${i}`).style.border = ' 1px solid red';
            this.submitButton.disabled = false;
            return
          }
        }
        for(var k in keys_to_check_min){
          var value = document.querySelector(`#${keys_to_check_min[k]}-${i}`).value;
          var min = document.querySelector(`#${keys_to_check_min[k]}-${i}`).getAttribute("min");
          if (parseFloat(value) < parseFloat(min)) {
            document.querySelector(`button[data-actab-id="${i}"]`).click();
            document.querySelector(`#${keys_to_check_min[k]}-${i}`).style.border = ' 1px solid red';
            this.submitButton.disabled = false;
            return
          }
        }
        var ext = (no_of_babies > 1) ? '-' + i : '';
        names.push(document.querySelector(`#birth-name-input-${i}`).value.toUpperCase())
        // obj[properties_translations['translation_name']+ext] = document.querySelector(`#birth-name-input-${i}`).value.toUpperCase();
        weights.push(document.querySelector('#birth-weight-text-'+i).textContent)
        // obj[properties_translations['translation_weight']+ext] = document.querySelector(`#birth-weight-input-${i}`).value + ' g';
        let day = document.querySelector(`[name="birth-date-day"][data-index="${i}"]`).value;
        let month = document.querySelector(`[name="birth-date-month"][data-index="${i}"]`).value;
        let year = document.querySelector(`[name="birth-date-year"][data-index="${i}"]`).value;
        let day_formatted = parseInt(day).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
        let date = document.querySelector(`[name="birth_date_format"][data-index="${i}"]`).value
                    .replace("[day]", day)
                    .replace("[day_formatted]", day_formatted)
                    .replace("[month]", month)
                    .replace("[year]", year)
        dates.push(date)
        // obj[properties_translations['translation_date']+ext] = document.querySelector(`#birth-date-day-${i}`).value + " " + document.querySelector(`#birth-date-month-${i}`).value + " " + document.querySelector(`#birth-date-year-${i}`).value;
        let time_unit = document.querySelector(`#birth-date-unit-${i}`);
        let time_unit_option = time_unit.options[time_unit.selectedIndex].getAttribute("data-value");
        times.push(document.querySelector(`#birth-time-hr-input-${i}`).value + ":" + document.querySelector(`#birth-time-min-input-${i}`).value + ((time_unit_option) ? time_unit_option : ''))
        // obj[properties_translations['translation_time']+ext] = document.querySelector(`#birth-time-hr-input-${i}`).value + ":" + document.querySelector(`#birth-time-min-input-${i}`).value;
        places.push(document.querySelector(`#birth-custom-input-${i}`).value)
        // obj[properties_translations['translation_place']+ext] = document.querySelector(`#birth-custom-input-${i}`).value;
        lengths.push(document.querySelector(`#birth-length-${i}`).textContent + ' ' + document.querySelector(`#birth-length-unit-${i}`).textContent.toLowerCase());
        obj[properties_translations['translation_length']+ext] = document.querySelector(`#birth-length-${i}`).getAttribute("data-length");
        obj[properties_translations['translation_illustration_direction']+ext] = $(`input[name="illustration_direction-${i}"]:checked`).val() == 'right' ? properties_translations['translation_right'] : properties_translations['translation_left'];
      }

      $('.as-cart-btn').next('.loading-overlay__spinner').removeClass('hidden');
      $('.as-cart-btn').children('span').css('visibility','hidden');
      $('.as-cart-btn').addClass('remove_before');
      const custom_image = await this.takeScreenshot();
      // console.log ('custom image ...', custom_image)
      
      let background_color = $('input[name="background_color"]:checked').val();
      let typeimg = $('input[name="background_color"]:checked').attr('data-type') == 'image';
      var background_image = 'Blue';
      if (typeimg){
        if (background_color.includes('Blue')){
          background_image = 'Blue';
        }
        else if (background_color.includes('Pink')){
          background_image = 'Pink';
        }
        else if (background_color.includes('Green')){
          background_image = 'Green';
        }
      }
      let illustration_color = $('input[name="illustration_color"]:checked').val();
      console.log('ILLUSTRATION IS ');
      console.log(illustration_color);
      let id = $(this).find('input[name="id"]').val();
      let selected_frame_or_hanger = $('input[name="frames_hangers"]:checked').val()

      console.log('onsubmit event listener called .....');
      // console.log('background color ....', background_color);
      // console.log('illustration color ......', illustration_color)
      // console.log('frames......', $('input[name="frames_hangers"]:checked').val());
      
   
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      // this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      // const config = fetchConfig('javascript');
      // config.headers['X-Requested-With'] = 'XMLHttpRequest';
      // delete config.headers['Content-Type'];

      let propertiesToAppend= { 'BackGroundColor': background_color,'IllustrationColor': illustration_color };
     
      let bg_type =  $('input[name="bg-frame-on__off"]:checked').val() == 0 ? properties_translations['translation_margin_background'] : properties_translations['translation_full_background'];
      // let showscale = document.getElementById('scale-text').style.display == 'none' ? properties_translations['translation_no'] : properties_translations['translation_yes'];
      let showscale = document.getElementById('scale-text').style.display == 'none' ? false : true;
      // const formData = new FormData(this.form);  
      let formData = {
        'items': [{ 
          'id': id,
          properties: {
            ...obj
          }
        }]
      };  

      formData['items'][0]['properties'][`row_1`] = `${(showscale ? document.querySelector('#scale_text_value').value + ' ' : '')}${names.join(' & ')}`;
      for (var i = 1; i <= no_of_babies; i++) {
        var line = `${lengths[i-1]} | ${weights[i-1]} | ${dates[i-1]}${(times[i-1] != ':') ? ' ' + times[i-1]: ''}`
        line = (places[i-1]) ? `${line} | ${places[i-1]}` : line;
        formData['items'][0]['properties'][`row_${i+1}`] = line;
      }
            
      if(!typeimg)     
      formData['items'][0]['properties'][properties_translations['translation_background_color_']] = colors[background_color].name;
      else
      formData['items'][0]['properties'][properties_translations['translation_background_image']] = background_image;

      formData['items'][0]['properties'][properties_translations['translation_illustration_color']] = colors[illustration_color].name;
      formData['items'][0]['properties'][properties_translations['translation_background']] = bg_type;

      // formData['items'][0]['properties'][properties_translations['translation_show_scale']] = showscale;
      formData['items'][0]['properties'][properties_translations['translation_image']] = custom_image;


      if( selected_frame_or_hanger ){
      if(selected_frame_or_hanger != "41087540428936")
        if (selected_frame_or_hanger != "41087542919304")
          formData['items'].push({ 'id': selected_frame_or_hanger });
      }
  
      if (this.dataset.cartType != 'page') {
        formData['sections'] = this.cart.getSectionsToRender().map((section) => section.id);
        formData['sections_url'] = window.location.pathname;
        // formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        // formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      
      // config.body = formData;


      fetch( window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        }
      )
        .then((response) => response.json())
        .then((response) => {
          console.log('response is ....',response);
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (this.dataset.cartType == 'page') {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error('error is ....',e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          $('.as-cart-btn').children('span').css('visibility','visible');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          this.submitButton.disabled = false;
        });

      
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    //custom image screen shot s3 upload
    takeScreenshot() {
      const response = new Promise (function (resolve, reject) {
      // var bucketName = "caseclubhtmlcanvas";
      // var bucketRegion = "us-east-1";
      // var IdentityPoolId = "us-east-1:5d9945a8-60d4-4bf4-bf59-64b79445bb80";
      var bucketName = "newbornposter";
      var bucketRegion = "us-east-1";
      var IdentityPoolId = "us-east-1:f9ca8273-bd68-474e-a0b3-5fc3e4063d87";
      var image_url = "";
  
      AWS.config.update({
        region: bucketRegion,
        credentials: new AWS.CognitoIdentityCredentials({ IdentityPoolId: IdentityPoolId })
      });
      var s3 = new AWS.S3({
        apiVersion: '2012-10-17',
        params: {Bucket: bucketName}
      });

      html2canvas(document.querySelector("#myDiv"), {allowTaint: true, useCORS: true, scale: 1}).then(canvas => {        

        canvas.toBlob((blob) => {
          if (blob != null) {
          var params = {
              Key: Date.now() + "." + blob.type.split("/")[1],
              Body: blob,
              ContentType: blob.type,
              ACL: 'public-read'
          }
          s3.upload(params, function(err, data) {
                if(err) {
                  console.log("checking error", err);
                  reject(err);
                } else {
                  image_url = data.Location;
                  resolve(image_url);
                  console.log("checking data", data.Location);
                }
            });
          }
        });
      });
    })
        return response;
    }

  });
}